export default __webpack_public_path__ + "static/media/fire.1de6fdad.svg";